import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { handleApiError } from '../../helpers';
import { useLocation, useParams } from 'react-router-dom';
import history from '../../helpers/history';
import { getSingleLoan } from '../../apis/loan';
import { Loan } from '../../interfaces';
import { useDispatch } from 'react-redux';
import { getLoan, UpdateLoanDisbursementChecker } from '../../states/action_creators/loan.action_creator';

export const useFetchSingleLoan = () => {
  const { id } = useParams<{ id: string }>();
  const { tab } = useParams<{ tab: string }>();
  const { pathname } = useLocation<{ pathname: string }>();
  const [fetching, setFetching] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchSingleLoan = async (id: number) => {
      try {
        setFetching(true);

        const response = await getSingleLoan(id);
        const loan: Loan = response.data.loan;
        const canDisburseLoan: boolean = response.data.canDisburseLoan;

        setFetching(false);
        dispatch(getLoan(loan));
        dispatch(UpdateLoanDisbursementChecker(canDisburseLoan));
      } catch (error) {
        setFetching(false);
        toast.error(handleApiError(error));
        dispatch(getLoan(null));
      }
    };

    fetchSingleLoan(+id);
  }, [id, dispatch]);

  useEffect(() => {
    if (!tab) {
      history.push(`/loan/${id}/information`);
    }
  }, [id, tab]);

  const makeActive = (path: string) => {
    const splitLocation = pathname.split('/');

    if (splitLocation[3]) {
      return splitLocation[3] === path ? 'active' : 'false';
    }
    return '';
  };

  return {
    tab,
    fetching,
    makeActive,
  };
};
